import React from "react";

const PaymentTypeBadge = ({ type }) => {
  const paymentType = (type || "").toLowerCase();
  const isCash = paymentType === "cash";
  const isWallet = paymentType === "wallet";
  const badgeStyle = {
    display: "inline-block",
    padding: "2px 10px",
    fontSize: 12,
    fontWeight: "bold",
    borderRadius: 8,
    color: "#fff",
    background: isCash ? "#008000" : isWallet ? "#ffa800" : "#ccc",
    minWidth: 40,
    textAlign: "center",
    textTransform: "capitalize",
    letterSpacing: 0.5,
  };
  return (
    <span style={badgeStyle}>
      {isCash ? "Cash" : isWallet ? "Wallet" : paymentType}
    </span>
  );
};

export default PaymentTypeBadge;
